module.exports = __webpack_public_path__ + "static/media/callingIcon.9fd0d87a.svg";